import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["id", "name", "type", "placeholder", "autocomplete"]

import { watch, ref } from "vue"
  import { useField } from "vee-validate"
  import { EyeIcon, EyeSlashIcon } from "@heroicons/vue/24/outline"
  import errorLabel from "./errorLabel.vue"

  interface Props {
    placeholder?: string
    id?: string
    name: string
    modelValue: string | number
    inputClass?: string
    autocomplete?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordTemplate',
  props: {
    placeholder: null,
    id: null,
    name: null,
    modelValue: null,
    inputClass: null,
    autocomplete: null
  },
  setup(__props: any) {

const props = __props as {
    placeholder?: string
    id?: string
    name: string
    modelValue: string | number
    inputClass?: string
    autocomplete?: string
  }

  
  const { value, errorMessage } = useField(props.name)
  const type = ref("password")

  const changeType = () => {
    type.value = type.value === "password" ? "text" : "password"
  }

  watch(
    () => props.modelValue,
    (val) => {
      if (val) value.value = val
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: __props.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
        name: props.name,
        type: type.value,
        class: _normalizeClass(["h-[45px] w-full rounded-xl pl-5 pr-12 bg-gray-highlight outline-none transition ease-out duration-200", props.inputClass]),
        placeholder: __props.placeholder,
        autocomplete: props.autocomplete || 'on'
      }, null, 10, _hoisted_3), [
        [_vModelDynamic, _unref(value)]
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: changeType
      }, [
        (type.value === 'password')
          ? (_openBlock(), _createBlock(_unref(EyeIcon), {
              key: 0,
              class: "w-5 text-light-gray-200 absolute top-0 right-0 mt-3 mr-4"
            }))
          : (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
              key: 1,
              class: "w-5 text-light-gray-200 absolute top-0 right-0 mt-3 mr-4"
            }))
      ])
    ]),
    _createVNode(errorLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(errorMessage)), 1)
      ]),
      _: 1
    })
  ]))
}
}

})